import React from "react";
import { Link } from "react-router-dom";
import phoneIcon from "~/assets/images/contact-modal/contact-phone-icon.svg";
import chatIcon from "~/assets/images/contact-modal/contact-chat-icon.svg";
import videoIcon from "~/assets/images/contact-modal/contact-video-icon.svg";
import Message from "~/model/message";
import { createOrderMeeting } from "~/helpers/backendHelper";
import { formatPhone, showError } from "~/helpers/utilHelper";

type TStepOptionsProps = {
  selectedPerson: any;
  onOpenChat: (channel: number) => void;
  personRoleLabel: string;
}

const StepOptions = ({ selectedPerson, onOpenChat, personRoleLabel }: TStepOptionsProps) => {

  const openChat = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // prevent the Link component from redirecting
    event.preventDefault();

    let channel;

    switch (selectedPerson.role) {
      case 'dealer':
        channel = Message.CHANNEL_DEALER_CUSTOMER;
        break;
      case 'scheduler':
        channel = Message.CHANNEL_SCHEDULER_CUSTOMER;
        break;
      case 'notary':
        channel = Message.CHANNEL_NOTARY_CUSTOMER;
        break;
    }

    onOpenChat(channel as number);
  };

  const startVideoCall = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    createMeeting(selectedPerson.role)
  };

  const createMeeting = async (role: string) => {
    let pendingWindow = null;
    try {
      // Open placeholder window synchronously
      pendingWindow = window.open('', '_blank');
      if (pendingWindow) {
        pendingWindow.document.body.innerHTML = `
       <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;background:#f9fbff;color:#1d4ed8;">
          <div style="border:6px solid #e0e7ff;border-top:6px solid #1d4ed8;border-radius:50%;width:60px;height:60px;animation:spin 1s linear infinite;"></div>
          <p style="margin-top:20px;font-size:32px;font-weight:600;">Loading meeting...</p>
          <style>
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          </style>
        </div>
      `;
      }
      // Create the order meeting
      const { link } = await createOrderMeeting(role) as any;
      if (!link) throw new Error('No meeting link returned');
      // Add the link received
      if (pendingWindow) {
        pendingWindow.location.href = link;
        pendingWindow = null;
      }
    } catch (err) {
      if (pendingWindow) {
        pendingWindow.close();
        pendingWindow = null;
      }
      showError("Unable to start meeting");
    }
  };

  return (
    <React.Fragment>
      <div className="contact-modal-header">
        <h4 className="contact-modal-title">Contact options</h4>
        <p className="contact-modal-subtitle">Choose one of the contact options</p>
      </div>
      <ul className="list-unstyled chat-list" id="recent-list">
        <li>
          <a href={`tel:${selectedPerson?.phone}`}>
            <div className="d-flex">
              <div className="align-self-center me-3">
                <img src={phoneIcon} alt="chat" />
              </div>

              <div className="flex-grow-1 overflow-hidden my-auto">
                <h5 className="contact-item-title text-truncate">
                  Phone call
                </h5>
                <p className="contact-item-subtitle text-truncate">
                  {selectedPerson.phone ? formatPhone(selectedPerson.phone) : "--"}
                </p>
              </div>
            </div>
          </a>
        </li>
        <li>
          <Link to={""} onClick={openChat}>
            <div className="d-flex">
              <div className="align-self-center me-3">
                <img src={chatIcon} alt="chat" />
              </div>

              <div className="flex-grow-1 overflow-hidden my-auto">
                <h5 className="contact-item-title text-truncate">
                  Chat
                </h5>
                <p className="contact-item-subtitle text-truncate">
                  {`${personRoleLabel} ${selectedPerson.role}`}
                </p>
              </div>
            </div>
          </Link>
        </li>
        <li>
          <Link to="" onClick={startVideoCall}>
            <div className="d-flex">
              <div className="align-self-center me-3">
                <img src={videoIcon} alt="chat" />
              </div>

              <div className="flex-grow-1 overflow-hidden my-auto">
                <h5 className="contact-item-title text-truncate">
                  Video call
                </h5>
              </div>
            </div>
          </Link>
        </li>
      </ul>
    </React.Fragment>
  )
}

export default StepOptions;